module.exports = __webpack_public_path__ + "static/media/44.7e188ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/44.jpg
// module id = 605
// module chunks = 0